import landing from './landing';
import start from './start';
import appeals from './appeals';
import rad from './rad';
import fileBDD from './file-bdd';
import unableToFileBDD from './unable-to-file-bdd';
import fileClaim from './file-claim';
import fileClaimEarly from './file-claim-early';
import disagreeFileClaim from './disagree-file-claim';

export default [
  landing,
  start,
  appeals,
  rad,
  fileBDD,
  unableToFileBDD,
  fileClaim,
  fileClaimEarly,
  disagreeFileClaim,
];
